export enum ReferenceType {
  TO_ONE,
  TO_MANY,
  TO_ONE_OR_MANY,
}
